import React from "react";
import { Link, useLocation } from "react-router-dom";
import {
  IoHomeOutline,
  IoHome,
  IoPersonOutline,
  IoPerson,
} from "react-icons/io5";
import {
  HiOutlineDotsHorizontal,
  HiOutlineShoppingCart,
  HiOutlineHeart,
} from "react-icons/hi";
import { MdOutlineReceiptLong, MdReceiptLong } from "react-icons/md";
import { useModal } from "../../context/ModalContext";
import { useAppSelector } from "../../hooks/hooks";

type Item = {
  key: string;
  label: string;
  to?: string;
  match?: (pathname: string) => boolean;
  Icon: React.ComponentType<{ className?: string }>;
  IconActive?: React.ComponentType<{ className?: string }>;
  placeholder?: boolean;
  requiresAuth?: boolean;
};

const items: Item[] = [
  {
    key: "home",
    label: "Home",
    to: "/",
    match: (p) => p === "/",
    Icon: IoHomeOutline,
    IconActive: IoHome,
  },
  // {
  //   key: "more",
  //   label: "Do More",
  //   Icon: HiOutlineDotsHorizontal,
  //   placeholder: true,
  // },
  {
    key: "buy",
    label: "DG Coins",
    Icon: HiOutlineShoppingCart,
    match: (p) => p === "/products/dg_coins/DGCoins",
    to: "/products/dg_coins/DGCoins",
  },
  {
    key: "orders",
    label: "Orders",
    to: "/order-history",
    match: (p) => p === "/order-history",
    Icon: MdOutlineReceiptLong,
    IconActive: MdReceiptLong,
    requiresAuth: true,
  },
  {
    key: "profile",
    label: "Profile",
    to: "/account",
    match: (p) => p === "/account" || p.startsWith("/account/"),
    Icon: IoPersonOutline,
    IconActive: IoPerson,
    requiresAuth: true,
  },
];

const BottomBar: React.FC = () => {
  const { pathname } = useLocation();
  const { user } = useAppSelector((state) => state.auth);
  const { openLoginModal } = useModal();

  return (
    <nav
      className="lg:hidden fixed bottom-0 left-0 right-0 z-40 px-3 pb-2"
      aria-label="Bottom navigation"
    >
      <div className="bg-white/60 dark:bg-[#111]/50 backdrop-blur-xl backdrop-saturate-150 border border-white/40 dark:border-white/10 rounded-2xl shadow-[0_-2px_20px_rgba(0,0,0,0.08)] flex items-center justify-between px-2 py-2">
        {items.map((item) => {
          const isActive = item.match ? item.match(pathname) : false;
          const Icon =
            isActive && item.IconActive ? item.IconActive : item.Icon;
          const content = (
            <div
              className={`flex flex-col items-center justify-center gap-1 px-2 py-1.5 rounded-xl min-w-[56px] ${
                isActive
                  ? "bg-[#039EF2]/10 text-[#039EF2]"
                  : "text-gray-600 dark:text-gray-300"
              }`}
            >
              <Icon className="w-5 h-5" />
              <span className="text-[11px] leading-none">{item.label}</span>
            </div>
          );

          if (item.placeholder || !item.to) {
            return (
              <button
                key={item.key}
                type="button"
                title="Coming soon"
                className="flex-1 flex items-center justify-center cursor-default"
                aria-disabled="true"
              >
                {content}
              </button>
            );
          }

          if (item.requiresAuth && !user) {
            return (
              <button
                key={item.key}
                type="button"
                onClick={openLoginModal}
                className="flex-1 flex items-center justify-center"
              >
                {content}
              </button>
            );
          }

          return (
            <Link
              key={item.key}
              to={item.to}
              className="flex-1 flex items-center justify-center"
              aria-current={isActive ? "page" : undefined}
            >
              {content}
            </Link>
          );
        })}
      </div>
    </nav>
  );
};

export default BottomBar;
